import Location from 'react-app-location';

export const HomeLocation = new Location('/');
export const ExpressInterestLocation = new Location('/express-interest');
export const SignInLocation = new Location('/sign-in');
